/*
 * nt-info-row.js — "Printed by Ninja" info row for the dtf-transfers PDP.
 *
 * The donor (ninjatransfers.com) builds its "price | Printed by Ninja | reviews"
 * header row in JS because sections/bySizeNew.liquid is over Shopify's 256 KB
 * template limit and cannot carry the markup itself (a section push is rejected
 * with "Template content exceeds 256 KB limit"). This is the Ninja-World,
 * UK-adapted, reviews-less version: it reformats the "As Low As" price to
 * "<price>/sq in" and appends a "Printed by Ninja. Ships from UK" pill (Union
 * Jack) beside it. Display-only and runs before upload — the existing
 * `body.image-uploaded .product-text > ._flex-box { display:none !important }`
 * rule hides the whole row once an image is uploaded, overriding our inline
 * flex, so no extra teardown is needed.
 */
(function () {
  if (window.__ntInfoRowPill) return;
  window.__ntInfoRowPill = true;

  var FLAG =
    '<svg width="18" height="12" viewBox="0 0 50 30" aria-hidden="true" style="flex:0 0 auto;border-radius:2px;display:block;">' +
      '<clipPath id="ntUkFlag"><rect width="50" height="30"/></clipPath>' +
      '<g clip-path="url(#ntUkFlag)">' +
        '<rect width="50" height="30" fill="#012169"/>' +
        '<path d="M0,0 L50,30 M50,0 L0,30" stroke="#fff" stroke-width="6"/>' +
        '<path d="M0,0 L50,30 M50,0 L0,30" stroke="#C8102E" stroke-width="3.5"/>' +
        '<path d="M25,0 V30 M0,15 H50" stroke="#fff" stroke-width="10"/>' +
        '<path d="M25,0 V30 M0,15 H50" stroke="#C8102E" stroke-width="6"/>' +
      '</g>' +
    '</svg>';

  function shouldRun() {
    var cls = (document.body && document.body.className) || '';
    return cls.indexOf('template-product-dtf-transfers') > -1
        || cls.indexOf('template-product-uv-by-size') > -1;
  }

  function build(row) {
    if (!row || row.getAttribute('data-nt-pill') === '1') return;

    // Reformat the price: drop the leading "- " and turn "per square inch" into "/sq in".
    var styled = row.querySelector('._styledtext');
    if (styled) {
      var firstStrong = styled.querySelector('strong');
      if (firstStrong && /^-/.test((firstStrong.textContent || '').trim())) firstStrong.remove();
      styled.innerHTML = styled.innerHTML.replace(/\s*per\s*square\s*inch\.?/i, '/sq in');
    }

    // Single flex row (the !important hide rule still wins after upload).
    row.style.display = 'flex';
    row.style.alignItems = 'center';
    row.style.flexWrap = 'wrap';
    row.style.gap = '10px';

    // "As Low As" (desktop) / "From" (mobile) toggle on the price label.
    var cost = row.querySelector('._cost_value');
    if (cost && !cost.querySelector('.nt-il-short')) {
      cost.innerHTML = '<span class="nt-il-long">' + cost.innerHTML + '</span><span class="nt-il-short">From&nbsp;</span>';
    }

    var sep = document.createElement('span');
    sep.setAttribute('aria-hidden', 'true');
    sep.style.cssText = 'flex:0 0 auto;width:1px;height:16px;background:#d9d9d9;';

    var pill = document.createElement('span');
    pill.style.cssText = 'display:inline-flex;align-items:center;gap:6px;font-size:0.9rem;line-height:normal;color:#111;font-weight:700;';
    // Full text on desktop, shortened ("Ships from UK") on mobile (<=749px).
    pill.innerHTML = FLAG + '<span class="nt-infoRow__pill-long">Printed by Ninja. Ships from UK</span><span class="nt-infoRow__pill-short">Ships from UK</span>';

    row.appendChild(sep);
    row.appendChild(pill);
    row.setAttribute('data-nt-pill', '1');
  }

  function run() {
    if (!shouldRun()) return true;          // wrong template — stop
    var cost = document.querySelector('.product-text ._flex-box ._cost_value');
    if (!cost) return false;                // "As Low As" row not painted yet
    build(cost.closest('._flex-box'));
    return true;
  }

  function boot() {
    if (run()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (run() || tries > 40) clearInterval(iv);   // retry ~10s then give up
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ── Feature icons (blue-outline) ──────────────────────────────────
   The deployed bySizeNew section renders an EMPTY .iconTextBlock — the 4
   feature items never shipped (section > 256 KB). Inject them with the
   donor's rounded-square blue-outline SVGs and long/short labels (short
   shown <=1199px). Grid + label-toggle CSS lives in nt-pdp-redesign.css. */
(function () {
  if (window.__ntFeatureIcons) return;
  window.__ntFeatureIcons = true;
  var BLUE = '#019AFF';

  function svgFor(kind) {
    /* No bounding box around the icons — just the glyph (the rounded-square <rect>
       outline was removed per request, on dtf-transfers + gang-sheet-builder).
       DTF kinds: fabric, vibrant, washes, shield.
       UV kinds:  hard_surface, drop, lightning, waterproof, badge_check, thumbs_up. */
    var head = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">';
    var glyph = '';
    switch (kind) {
      case 'fabric':
        glyph = '<path d="M11 7c0 1.7 1.3 3 3 3s3-1.3 3-3M9 8L7 9v3l2 1v8h10v-8l2-1V9l-2-1-2-1h-2l-3 2-3-2H11L9 8z" stroke="' + BLUE + '" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none"/>';
        break;
      case 'vibrant':
        glyph = '<path d="M14 6.5l1.6 4 4 1.6-4 1.6-1.6 4-1.6-4-4-1.6 4-1.6L14 6.5z" stroke="' + BLUE + '" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
                '<path d="M20 17.5l.7 1.6 1.6.7-1.6.7-.7 1.6-.7-1.6-1.6-.7 1.6-.7.7-1.6z" fill="' + BLUE + '"/>';
        break;
      case 'washes':
        glyph = '<rect x="7" y="6.5" width="14" height="15" rx="2" stroke="' + BLUE + '" stroke-width="1.4"/>' +
                '<circle cx="14" cy="15" r="3.5" stroke="' + BLUE + '" stroke-width="1.4"/>' +
                '<circle cx="14" cy="15" r="1.2" stroke="' + BLUE + '" stroke-width="1.2"/>' +
                '<circle cx="10" cy="9" r="0.7" fill="' + BLUE + '"/>' +
                '<circle cx="12.5" cy="9" r="0.7" fill="' + BLUE + '"/>';
        break;
      case 'shield':
        glyph = '<path d="M14 6.5l5.5 2v4.5c0 4-2.5 6-5.5 7-3-1-5.5-3-5.5-7V8.5L14 6.5z" stroke="' + BLUE + '" stroke-width="1.4" stroke-linejoin="round" fill="none"/>' +
                '<path d="M11.5 13.5l1.7 1.7 3.3-3.3" stroke="' + BLUE + '" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>';
        break;
      /* UV-specific glyphs — drawn to read against transparent background at 28x28. */
      case 'hard_surface':
        /* 3x3 grid of dots (the donor's "Works on Any Hard Surface" pattern). */
        glyph = '<circle cx="9" cy="9" r="1.2" fill="' + BLUE + '"/>' +
                '<circle cx="14" cy="9" r="1.2" fill="' + BLUE + '"/>' +
                '<circle cx="19" cy="9" r="1.2" fill="' + BLUE + '"/>' +
                '<circle cx="9" cy="14" r="1.2" fill="' + BLUE + '"/>' +
                '<circle cx="14" cy="14" r="1.2" fill="' + BLUE + '"/>' +
                '<circle cx="19" cy="14" r="1.2" fill="' + BLUE + '"/>' +
                '<circle cx="9" cy="19" r="1.2" fill="' + BLUE + '"/>' +
                '<circle cx="14" cy="19" r="1.2" fill="' + BLUE + '"/>' +
                '<circle cx="19" cy="19" r="1.2" fill="' + BLUE + '"/>';
        break;
      case 'drop':
        /* Ink-drop split vertically — left half filled, right half outline (the
           "Vibrant Colors" half-and-half drop). */
        glyph = '<path d="M14 5c-3 4-5 7-5 10a5 5 0 0 0 10 0c0-3-2-6-5-10z" stroke="' + BLUE + '" stroke-width="1.4" stroke-linejoin="round" fill="none"/>' +
                '<path d="M14 5c-3 4-5 7-5 10a5 5 0 0 0 5 5V5z" fill="' + BLUE + '"/>';
        break;
      case 'lightning':
        /* Lightning bolt — Quick & Easy to Apply. */
        glyph = '<path d="M15 4l-7 12h5l-2 8 8-12h-5l1-8z" stroke="' + BLUE + '" stroke-width="1.4" stroke-linejoin="round" fill="none"/>';
        break;
      case 'waterproof':
        /* Shield with vertical waterdrop inside — Waterproof & Long Lasting. */
        glyph = '<path d="M14 5l6 2.2v4.8c0 4.4-2.7 6.6-6 7.5-3.3-.9-6-3.1-6-7.5V7.2L14 5z" stroke="' + BLUE + '" stroke-width="1.4" stroke-linejoin="round" fill="none"/>' +
                '<path d="M14 10c-1.4 1.8-2.3 3.3-2.3 4.6a2.3 2.3 0 0 0 4.6 0c0-1.3-.9-2.8-2.3-4.6z" stroke="' + BLUE + '" stroke-width="1.3" stroke-linejoin="round" fill="none"/>';
        break;
      case 'badge_check':
        /* Scalloped/star badge with check — 100% Satisfaction Guaranteed. */
        glyph = '<path d="M14 4l1.9 1.6 2.5-.4.7 2.4 2.3 1.1-1 2.3 1 2.3-2.3 1.1-.7 2.4-2.5-.4L14 22l-1.9-1.6-2.5.4-.7-2.4-2.3-1.1 1-2.3-1-2.3 2.3-1.1.7-2.4 2.5.4L14 4z" stroke="' + BLUE + '" stroke-width="1.3" stroke-linejoin="round" fill="none"/>' +
                '<path d="M10.8 13.5l2.2 2.2 4.2-4.2" stroke="' + BLUE + '" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>';
        break;
      case 'thumbs_up':
        /* Thumbs-up — No Minimums or Setup Fees. */
        glyph = '<path d="M9 13v8h2v-8H9z" stroke="' + BLUE + '" stroke-width="1.3" stroke-linejoin="round" fill="none"/>' +
                '<path d="M11 13l3-7a1.8 1.8 0 0 1 3.4 1l-1 4h4.2a1.6 1.6 0 0 1 1.6 1.9l-1.2 6.2A1.6 1.6 0 0 1 19.5 21H11" stroke="' + BLUE + '" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" fill="none"/>';
        break;
      default: return '';
    }
    return head + glyph + '</svg>';
  }

  var DTF_ITEMS = [
    { kind: 'fabric',  long: 'Works on Any Fabric or Colour',       short: 'Any fabric or colour' },
    { kind: 'vibrant', long: 'Vibrant Colours &amp; Ultra-fine Details', short: 'Vibrant Colours &amp; Details' },
    { kind: 'washes',  long: 'Certified for 100+ Washes',           short: '100+ Washes', info: true },
    { kind: 'shield',  long: '100% Satisfaction Guaranteed',         short: 'Satisfaction Guaranteed' }
  ];

  /* UV DTF Stickers use inline blue-outline glyphs matching the dtf-transfers
     visual style (transparent wrap, #019AFF strokes) — six items in a 2-col
     grid (3 rows) on desktop, 2-col on mobile. */
  var UV_ITEMS = [
    { kind: 'hard_surface', long: 'Works on Any Hard Surface',               short: 'Any Hard Surface' },
    { kind: 'drop',         long: 'Vibrant Colours &amp; Ultra-fine Details',  short: 'Vibrant Colours &amp; Details' },
    { kind: 'lightning',    long: 'Quick &amp; Easy to Apply',                short: 'Quick &amp; Easy' },
    { kind: 'waterproof',   long: 'Waterproof &amp; Long Lasting Durability', short: 'Waterproof &amp; Durable' },
    { kind: 'badge_check',  long: '100% Satisfaction Guaranteed',             short: 'Satisfaction Guaranteed' },
    { kind: 'thumbs_up',    long: 'No Minimums or Setup Fees',                short: 'No Minimums or Fees' }
  ];

  function templateKind() {
    var cls = (document.body && document.body.className) || '';
    if (cls.indexOf('template-product-uv-by-size') > -1) return 'uv';
    if (cls.indexOf('template-product-dtf-transfers') > -1) return 'dtf';
    return null;
  }
  function shouldRun() { return templateKind() !== null; }

  function run() {
    var kind = templateKind();
    if (!kind) return true;
    var block = document.querySelector('.product-text .iconTextBlock');
    if (!block) return false;
    if (block.getAttribute('data-nt-icons') === '1') return true;
    if (block.children.length > 0) { block.setAttribute('data-nt-icons', '1'); return true; } // section already populated it
    var html = '';
    if (kind === 'uv') {
      block.setAttribute('data-nt-icons-uv', '1');
      UV_ITEMS.forEach(function (it) {
        html += '<div class="iconTextBlock__item nt-ic-item" data-nt-kind="' + it.kind + '">' +
                  '<span class="iconTextBlock__iconWrap nt-ic-wrap">' + svgFor(it.kind) + '</span>' +
                  '<p class="iconTextBlock__iconText"><span class="nt-ic-long">' + it.long + '</span><span class="nt-ic-short">' + it.short + '</span></p>' +
                '</div>';
      });
    } else {
      DTF_ITEMS.forEach(function (it) {
        html += '<div class="iconTextBlock__item nt-ic-item" data-nt-kind="' + it.kind + '">' +
                  '<span class="iconTextBlock__iconWrap nt-ic-wrap">' + svgFor(it.kind) + '</span>' +
                  '<p class="iconTextBlock__iconText"><span class="nt-ic-long">' + it.long + '</span><span class="nt-ic-short">' + it.short + '</span>' + (it.info ? ' <span class="nt-ic-info" role="button" tabindex="0" aria-label="Lab tested for 100+ washes — more info">i</span>' : '') + '</p>' +
                '</div>';
      });
    }
    block.innerHTML = html;
    block.setAttribute('data-nt-icons', '1');
    return true;
  }

  function boot() {
    if (run()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (run() || tries > 40) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ── Mobile: rebuild .buyMoreSave as a 3-card grid (tag / countdown / fees) ──
   Ported from the donor's bms-v2 (precut-v3-injector.js), UK-adapted ("£0 Fees").
   Builds a NEW wrapper next to .buyMoreSave — keeping the live
   <fastest-deliver-placeholder> countdown intact — and mirrors its date/time
   <strong>s into the card. CSS (nt-pdp-redesign.css) shows the cards <=749px
   and the horizontal divider row above that. */
(function () {
  if (window.__ntBmsCards) return;
  window.__ntBmsCards = true;
  var BLUE = '#019AFF';

  function shouldRun() {
    var cls = (document.body && document.body.className) || '';
    return cls.indexOf('template-product-dtf-transfers') > -1
        || cls.indexOf('template-product-uv-by-size') > -1;
  }
  function tagSvg() {
    return '<svg width="22" height="22" viewBox="0 0 24 24" fill="' + BLUE + '" aria-hidden="true">' +
      '<path d="M21.41 11.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9a2 2 0 0 0 2.82 0l7-7a2 2 0 0 0 0-2.84z"/>' +
      '<circle cx="7.5" cy="7.5" r="1.5" fill="#fff"/></svg>';
  }
  function boxSvg() {
    return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="' + BLUE + '" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>' +
      '<polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/><path d="M16.5 9.4l-9-5.19"/></svg>';
  }
  function poundSvg() {
    return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="' + BLUE + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="10"/>' +
      '<text x="12" y="16.5" text-anchor="middle" font-size="11" font-weight="700" fill="' + BLUE + '" stroke="none" font-family="Inter,sans-serif">£</text></svg>';
  }
  var COL = 'display:flex;flex-direction:column;align-items:center;text-align:center;gap:2px;';
  var PRIM = 'font-size:14px;font-weight:700;color:' + BLUE + ';line-height:1.2;';
  var CAP = 'font-size:11px;color:#6b7280;font-weight:400;';

  function run() {
    if (!shouldRun()) return true;
    var bms = document.querySelector('.product-text .buyMoreSave');
    if (!bms) return false;
    if (bms.getAttribute('data-nt-bms-cards') === '1') return true;
    var bmLink = bms.querySelector('a');
    var bmHref = (bmLink && bmLink.getAttribute('href')) || 'javascript:void(0)';
    var ph = bms.querySelector('fastest-deliver-placeholder');

    // Place the cards UNDER the upload box as a vertical list (image-2 layout:
    // boxed icon + bold-blue title + grey subtitle per row). The upload box is
    // <master-upload>; bail until it exists so the position is correct.
    var host = document.querySelector('master-upload');
    if (!host) return false;

    var wrap = document.createElement('div');
    wrap.className = 'nt-bms-cards';
    wrap.innerHTML =
      '<a class="nt-bms-cards__row openPriceCalculator" href="' + bmHref + '">' +
        '<span class="nt-bms-cards__icon">' + tagSvg() + '</span>' +
        '<span class="nt-bms-cards__text"><span class="nt-bms-cards__title">Save Up to 50% off</span><span class="nt-bms-cards__sub">Buy More And Save</span></span>' +
      '</a>' +
      '<div class="nt-bms-cards__row">' +
        '<span class="nt-bms-cards__icon">' + boxSvg() + '</span>' +
        '<span class="nt-bms-cards__text"><span class="nt-bms-cards__title">Order in <span data-nt-cd></span></span><span class="nt-bms-cards__sub" data-nt-cd-cap></span></span>' +
      '</div>' +
      '<div class="nt-bms-cards__row">' +
        '<span class="nt-bms-cards__icon">' + poundSvg() + '</span>' +
        '<span class="nt-bms-cards__text"><span class="nt-bms-cards__title">No Minimums, Setup or Art Fees</span><span class="nt-bms-cards__sub">The Ninja Guarantee</span></span>' +
      '</div>';
    host.insertAdjacentElement('afterend', wrap);

    if (ph) {
      var cdEl = wrap.querySelector('[data-nt-cd]');
      var capEl = wrap.querySelector('[data-nt-cd-cap]');
      var sync = function () {
        var strongs = ph.querySelectorAll(':scope > strong');
        var dateTxt = strongs[0] ? strongs[0].textContent.trim() : '';
        var timeTxt = strongs[1] ? strongs[1].textContent.trim() : '';
        // Primary = the live countdown ONLY. Never write the date here, and skip
        // empty reads (keep the last timer value), so it can't flicker between the
        // timer and the date as <time> updates each second.
        if (cdEl && timeTxt) cdEl.textContent = timeTxt;
        if (capEl && dateTxt) capEl.textContent = 'For Fastest Delivery ' + dateTxt;
      };
      sync();
      try { new MutationObserver(sync).observe(ph, { childList: true, characterData: true, subtree: true }); } catch (e) {}
      setInterval(sync, 1000);
    }
    bms.setAttribute('data-nt-bms-cards', '1');
    return true;
  }
  function boot() {
    if (run()) return;
    var tries = 0;
    var iv = setInterval(function () { tries++; if (run() || tries > 40) clearInterval(iv); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ── Mobile: shorten the title badge "FREE Upgrade to VIVID AF" → "VIVID AF".
   DTF-only — UV by-size has no VIVID AF badge (intentionally removed). ── */
(function () {
  if (window.__ntBadgeShort) return;
  window.__ntBadgeShort = true;
  function isDtf() {
    return ((document.body && document.body.className) || '').indexOf('template-product-dtf-transfers') > -1;
  }
  function run() {
    if (!isDtf()) return true;                // UV: no badge to shorten, stop polling
    var badge = document.querySelector('.product-text .titleBadge') || document.querySelector('.titleBadge');
    if (!badge) return false;
    if (!badge.getAttribute('data-nt-full')) badge.setAttribute('data-nt-full', badge.textContent.trim());
    var apply = function () {
      var mob = window.matchMedia('(max-width: 749px)').matches;
      badge.textContent = mob ? 'VIVID AF' : (badge.getAttribute('data-nt-full') || badge.textContent);
      // Signal to CSS that the text has been swapped; the mobile-only
      // visibility:hidden rule (nt-pdp-redesign.css) only applies BEFORE this,
      // so the user never sees the long "FREE Upgrade to VIVID AF" on mobile.
      badge.setAttribute('data-nt-applied', '1');
    };
    apply();
    window.addEventListener('resize', apply);
    return true;
  }
  function boot() {
    if (run()) return;
    var t = 0;
    var iv = setInterval(function () { t++; if (run() || t > 40) clearInterval(iv); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ── "Your Image" / "Size Guide" mobile tabs (after upload, dtf-transfers) ──
   Ports the post-upload tab UI from ninjatransfers.com. snippets/mobile-preview-
   size-guide-tabs.liquid already has the same UX for THREE sibling templates
   (by-size-tabs / by-size-bg-options / uv-dtf-by-size) but its render gate in
   bySizeNew.liquid excludes dtf-transfers, and that section is over Shopify's
   256 KB push limit so we can't add dtf-transfers to the gate. Workaround:
   inject the tab bar markup via JS, wire the tab switching via body classes
   (`nt-mptab-preview` / `nt-mptab-size-guide`), and let nt-pdp-redesign.css
   handle the layout/visibility rules. Mirrors the snippet's behavior exactly. */
(function () {
  if (window.__ntMpTabsDtf) return;
  window.__ntMpTabsDtf = true;
  function isDtf() {
    var cls = (document.body && document.body.className) || '';
    return cls.indexOf('template-product-dtf-transfers') > -1
        || cls.indexOf('template-product-uv-by-size') > -1;
  }
  function setActiveTab(tab) {
    var b = document.body;
    b.classList.remove('nt-mptab-preview', 'nt-mptab-size-guide');
    b.classList.add('nt-mptab-' + tab);
    document.querySelectorAll('[data-nt-mptabs]').forEach(function (bar) {
      bar.removeAttribute('hidden');
      bar.querySelectorAll('.nt-mptabs__tab').forEach(function (t) {
        var isActive = t.getAttribute('data-nt-mptab') === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    });
  }
  function injectTabs() {
    if (!isDtf()) return false;
    if (document.querySelector('[data-nt-mptabs]')) return true;
    var pp = document.querySelector('product-page');
    if (!pp) return false;
    var bar = document.createElement('div');
    bar.className = 'nt-mptabs';
    bar.setAttribute('data-nt-mptabs', '');
    bar.setAttribute('role', 'tablist');
    bar.setAttribute('aria-label', 'Preview or Size Guide');
    bar.innerHTML =
      '<button type="button" class="nt-mptabs__tab is-active" data-nt-mptab="preview" role="tab" aria-selected="true">Your Image</button>' +
      '<button type="button" class="nt-mptabs__tab" data-nt-mptab="size-guide" role="tab" aria-selected="false">Size Guide</button>';
    pp.insertBefore(bar, pp.firstChild);
    return true;
  }
  function boot() {
    if (!isDtf()) return;
    setActiveTab('preview');               // default tab on every page load
    injectTabs();
    // If product-page isn't in the DOM yet, retry briefly.
    if (!document.querySelector('[data-nt-mptabs]')) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (injectTabs() || tries > 40) clearInterval(iv);
      }, 250);
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nt-mptab]');
      if (!btn) return;
      setActiveTab(btn.getAttribute('data-nt-mptab'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ── "Lab Tested for 100+ Washes" click MODAL (image + lab-test copy). ──
   Opens when the .nt-ic-info badge in the buy-box icon row is clicked.
   Runs on both the dtf-transfers and gang-sheet-builder PDPs (the badge is
   rendered by this file on by-size, and by the custom_liquid block on gang
   sheet). Image is hotlinked from the Ninja Transfers Shopify CDN. */
(function () {
  if (window.__ntWashModal) return;
  window.__ntWashModal = true;

  var IMG = 'https://cdn.shopify.com/s/files/1/0558/0265/8899/files/dtf-transfers-by-sizeninja-transfers-549133.png?width=900';
  var TXT = 'Ninja Transfers Easy Peel DTF Transfers have been rigorously tested to ensure long-lasting durability. After undergoing 100 machine wash cycles (30°C, normal cycle, line dry) on a 100% cotton shirt, the transfers were evaluated for colour retention, peeling, cracking, and overall integrity. The results were overwhelmingly positive, with a "Satisfactory" grade across all criteria, including negligible hand-feel change and no significant signs of delamination or print detachment.';
  var modal = null;

  function build() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'nt-wash-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="nt-wash-modal__overlay" data-nt-close></div>' +
      '<div class="nt-wash-modal__card" role="dialog" aria-modal="true" aria-label="Lab Tested for 100+ Washes">' +
        '<button class="nt-wash-modal__close" type="button" data-nt-close aria-label="Close">&times;</button>' +
        '<img class="nt-wash-modal__img" src="' + IMG + '" alt="Lab Tested for 100+ Washes — 0 washes vs 100 washes comparison">' +
        '<p class="nt-wash-modal__text"></p>' +
      '</div>';
    modal.querySelector('.nt-wash-modal__text').textContent = TXT;
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target && e.target.hasAttribute('data-nt-close')) close();
    });
    return modal;
  }
  function open() { build(); modal.hidden = false; document.body.classList.add('nt-wash-open'); }
  function close() { if (modal) { modal.hidden = true; document.body.classList.remove('nt-wash-open'); } }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest('.iconTextBlock .nt-ic-info')) { e.preventDefault(); open(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    // Enter/Space on the focused badge opens it
    if ((e.key === 'Enter' || e.key === ' ') && document.activeElement &&
        document.activeElement.closest && document.activeElement.closest('.iconTextBlock .nt-ic-info')) {
      e.preventDefault(); open();
    }
  });
})();
